import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import language from '../../js/stores/language.js';
import car from '../../js/stores/car.js';
import Pager from '../../pages/components/pager.f7.html';
import CarCard from './components/card.f7.html';
function framework7Component(props, _ref) {
  var $ = _ref.$,
    $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted,
    $f7route = _ref.$f7route,
    $f7router = _ref.$f7router;
  var locale = language.getters.Item.value;
  var carList = [];
  var pagerParams = {};
  var rowsPerPage = 4;
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return callPager({
            rows: rowsPerPage
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  var callPager = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _ref4,
        _ref4$page,
        page,
        _ref4$rows,
        rows,
        _ref4$sidx,
        sidx,
        _ref4$sdir,
        sdir,
        _ref4$filter,
        filter,
        result,
        _args2 = arguments;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _ref4 = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {}, _ref4$page = _ref4.page, page = _ref4$page === void 0 ? 1 : _ref4$page, _ref4$rows = _ref4.rows, rows = _ref4$rows === void 0 ? 4 : _ref4$rows, _ref4$sidx = _ref4.sidx, sidx = _ref4$sidx === void 0 ? 0 : _ref4$sidx, _ref4$sdir = _ref4.sdir, sdir = _ref4$sdir === void 0 ? 0 : _ref4$sdir, _ref4$filter = _ref4.filter, filter = _ref4$filter === void 0 ? "" : _ref4$filter;
            _context2.next = 1;
            return car.dispatch('getCarList', {
              page: page,
              rows: rows,
              sidx: sidx,
              sdir: sdir,
              filter: filter
            });
          case 1:
            result = _context2.sent;
            if (!(result.status !== undefined && result.status !== 200)) {
              _context2.next = 2;
              break;
            }
            $f7.toast.show({
              text: result.data.messages.error
            });
            return _context2.abrupt("return");
          case 2:
            carList = result.rows;
            pagerParams = {
              "currentPage": result.currentPage,
              "totalRecords": result.totalRecords,
              "totalPages": result.totalPages
            };
            $update();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function callPager() {
      return _ref3.apply(this, arguments);
    };
  }();
  var goPage = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(value) {
      var params;
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            params = value.detail;
            _context3.next = 1;
            return callPager(params);
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function goPage(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="car-dashboard">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">Back</span>
        </a>
      </div>
      <div class="title">${locale.translate('car.dashboard.title')}</div>
    </div>
  </div>
  <div class="page-content">
    <div class="prev">
      <div class="left-side sub-item hidden-xs-down">
      </div>
      <div class="center-side sub-item">
        <div class="block-title">${locale.translate('car.dashboard.carList')}</div>
        <div class="block">
          <${CarCard} list=${carList}/>
          <${Pager} params=${pagerParams} @myEvent=${goPage} rows-per-page=${rowsPerPage} />
        </div>
      </div>
      <div class="right-side sub-item hidden-xs-down">
      </div>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = '7ae2468b9e';
export default framework7Component;